import { render, staticRenderFns } from "./DialogoCategorias.vue?vue&type=template&id=aaa72dd6&"
import script from "./DialogoCategorias.vue?vue&type=script&lang=js&"
export * from "./DialogoCategorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports